import React from 'react';
import Card from 'components/Card';
import Button from 'components/Button';
import StickyBox from 'components/StickyBox';
function EditorPageStickySaveButton(_ref) {
  var isDisabled = _ref.isDisabled,
    isLoading = _ref.isLoading,
    buttonText = _ref.buttonText,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(StickyBox, {
    placement: "bottom",
    borderRadius: "large",
    mt: "m"
  }, /*#__PURE__*/React.createElement(Card, {
    px: "m",
    py: "s",
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    type: "submit",
    isDisabled: isDisabled,
    isLoading: isLoading,
    icon: "ok",
    onClick: onClick
  }, buttonText)));
}
export default EditorPageStickySaveButton;